import { LENGTH_OF_INCOME_OPTIONS } from 'helpers/Constants';
import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

export default {
  defaultNextPage: 'page-8',
  content: [
    configureProgressBar(34),
    configureTitle('How long have you been employed here?'),
    {
      component: ButtonGroup,
      name: 'lengthOfReceivingIncome',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'lengthOfReceivingIncome',
        direction: 'column',
        options: LENGTH_OF_INCOME_OPTIONS
      }
    },
    nextButtonConfig('page-7.2')
  ]
};
